import formatMoney from '../../core/formatMoney';
// import { initFriendFamilyShare } from './friends-family-share';
import checkProductsExist from './check-products-exist';
// import initShareFacebookWishlist from './facebook-share';
import { initSharedWishlistPage } from './shared-wishlist';
import initLinkShare from './link-share';
import initSavedForLaterTiles from './save-for-later';
import initMoveToWishlist from './move-to-wishlist';
import initRemoveFromWishlist from './remove-from-wishlist';
import initMoveToCart from './move-to-cart';
import getProductID from './get-product-id';
import getTileHTML from './get-tile-html';
// import { openSliderCart } from '../../sections/slider-cart';

// Save the list products on load to be able to send the object on remove
window.wishlist_products = [];

// Collection page / Search overlay
const initProductTileWishlist = () => {
  function swymCallbackTileFn (swat) {
    document.addEventListener('tile-variant:change', (e) => {
      try {
        const variant_id = e.data.detail.variantId;
        const $tile = e.data.detail.tile;
        const selector = `[data-product-tile][data-product-id="${$tile.data('product-id')}"] [data-product-swym-wishlist]`;
  
        const swym_qv = document.querySelector(selector);
        if (swym_qv === null || typeof swym_qv === 'undefined') {
          return;
        }

        swym_qv.setAttribute('data-variant-id', variant_id);
        swat.initializeActionButtons(`[data-product-tile][data-product-id="${$tile.data('product-id')}"]`);
      } catch (e) {
        console.log(e);
      }
    });
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(swymCallbackTileFn);
};

const initWishlistTiles = () => {
  const wishlistItemsContainer = document.getElementById('wishlist-items');

  if (!wishlistItemsContainer) {
    return;
  }

  window._swat.fetch((wishlistProducts) => {
    // console.log('wishlistProducts', wishlistProducts);
    window.wishlist_products = wishlistProducts;

    // Remove loading indicator
    document.querySelectorAll('[data-cart-wishlist-loading]').forEach(el => el.remove());

    if (!wishlistProducts.length) {
      // Cart page
      if (document.querySelector('[data-cart-wishlist-empty]')) {
        document.querySelector('[data-cart-wishlist-empty]').classList.add('visible');
      }

      // User's wishlist page
      if (document.querySelector('.user-wishlist__empty')) {
        document.querySelectorAll('[data-cart-wishlist-empty]').forEach(el => el.remove());
        document.querySelector('.user-wishlist__empty').classList.remove('visually-hidden');
      }
      return;
    }

    // Need to remove it to avoid messing up the tiles grid
    document.querySelectorAll('[data-cart-wishlist-empty]').forEach(el => el.remove());

    // Show the share section on the user's wishlist page
    if (document.querySelector('.user-wishlist-share')) {
      document.querySelector('.user-wishlist-share').classList.remove('visually-hidden');
    }

    let count_whishlist_item = 0;
    wishlistProducts.forEach((wishlistProduct) => {
      try {
        const wishlist_product_id = getProductID(wishlistProduct);
        wishlistProduct.id = wishlist_product_id;

        if (wishlist_product_id !== null) {
          const option_html = getTileHTML(wishlistProduct, wishlistItemsContainer);

          const optionsEl = document.querySelector(`[data-cart-wishlist-items] [data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-options]`);
          if (optionsEl) optionsEl.innerHTML = option_html;

          const priceEl = document.querySelector(`[data-cart-wishlist-items] [data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-price]`);
          if (priceEl) {
            if (window.Shopify.country === 'US') {
              priceEl.innerHTML = formatMoney(Number(wishlistProduct.pr) * 100, theme.moneyFormat);
            } else {
              priceEl.innerHTML = formatMoney(Math.ceil(Number(wishlistProduct.pr) * window.Shopify.currency.rate) * 100, theme.moneyFormat);
            }
          }

          // Cleanup title
          let product_title = wishlistProduct.dt;
          if (product_title.indexOf(' - ') !== -1) {
            const product_title_parts = product_title.split(' - ');
            const last_title_part = product_title_parts[product_title_parts.length - 1];
            product_title = product_title.replace(` - ${last_title_part}`, '');
            const titleEl = document.querySelector(`[data-cart-wishlist-items] [data-cart-wishlist-item-id="${wishlist_product_id}"] [data-cart-wishlist-item-title]`);
            if (titleEl) titleEl.innerHTML = product_title;
          }

          count_whishlist_item++;

          // User might have a product that doesn't exist in store in its wishlist, remove it if it's the case
          if (count_whishlist_item === wishlistProducts.length) {
            checkProductsExist(wishlistProducts, 'wishlist');
          }

          window.dispatchEvent(new Event('resize'));
        }
      } catch (error) {
        console.log('Wishlist error', error);
      }
    });
  }, window._swat.EventTypes.addToWishList);
};

let swym_ready_checks = 0;
const swymCallbackFn = () => {
  return new Promise(async (resolve, reject) => {
    if (typeof window._swat === 'undefined' && swym_ready_checks < 5) {
      window.setTimeout(() => {
        swym_ready_checks++;
        swymCallbackFn();
      }, 1000);

      return;
    }

    initWishlistTiles();
    initSavedForLaterTiles();

    resolve(true);
  });
};

// List tiles (Wishlist and Saved for Later)
const initListTiles = () => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  initMoveToCart();

  window.SwymCallbacks.push(swymCallbackFn);
};

// Gets initialized on every pages from theme.js
const initWishlist = () => {
  // Redirects to custom wishlist page
  if (window.location.href.indexOf('/apps/swymWishlist/wishlist/') !== -1 || window.location.href.indexOf('/pages/swym-wishlist') !== -1) {
    window.location.href = `${window.Shopify.routes.root}pages/wishlist/`;
  }

  // We want to sync the icon on product overview, sticky add to cart mobile and desktop
  // But it looks like we're only able to get the event when removing the item from the wishlist
  // $(document).on('click', '[data-product-details-wishlist]', (e) => {
  //   const $item = $(e.currentTarget).find('[data-product-swym-wishlist]');
  //   const is_removing = $item.hasClass('swym-added');

  //   if (is_removing) {
  //     $('[data-product-swym-wishlist]').removeClass('swym-added');

  //     $('[data-product-swym-wishlist]').each((wishlist_button) => {
  //       $(wishlist_button).removeClass('swym-added');
  //     });
  //   } else {
  //     $('[data-product-swym-wishlist]').each((wishlist_button) => {
  //       $(wishlist_button).addClass('swym-added');
  //     });
  //   }
  // });

  // if (!$('[data-product-swym-wishlist]').length && window.location.pathname.indexOf('swymWishlist') === -1) {
  //   return;
  // }

  // Collection pages / Search overlay
  initProductTileWishlist();

  // Product overview on PDP only
  // if (window._swat && $('.product-actions__wishlist').length) {
  //   window._swat.initializeActionButtons('.product-actions__wishlist');
  // }
  // try {
  //   if (window._swat && $('.swym-add-to-wishlist-view-product').length) {
  //     window._swat.initializeActionButtons('.swym-add-to-wishlist-view-product');
  //   }
  // } catch (error) {
  //   console.log(error);
  // }

  // Native wishlist landing ONLY /apps/swymWishlist/wishlist/
  /*
  if (window.location.pathname.indexOf('swymWishlist') !== -1) {
    const wishlist_landing_ready = window.setInterval(() => {
      if ($('body').hasClass('swym-ready')) {
        window.dispatchEvent(new Event('resize'));
        removeAddedItems();

        window.setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 1000);
        window.clearInterval(wishlist_landing_ready);
      }
    }, 250);
  }
  */

  if ($('#wishlist-items').length || $('#saveforlater-items').length) {
    initListTiles();
  }

  // Custom wishlist landing and cart page
  if ($('#wishlist-items').length) {
    // initShareFacebookWishlist();
    initMoveToWishlist();
    initRemoveFromWishlist();
  }

  // Share wishlist friends & family
  // initFriendFamilyShare();

  // Shared wishlist page
  // https://www.astrthelabel.com/pages/shared-wishlist?hkey=93d27de5-5845-4feb-96c6-d98860dc959e&lid=93d27de5-5845-4feb-96c6-d98860dc959e
  initSharedWishlistPage();

  if ($('[data-open-share-wishlist-link-modal]').length) {
    initLinkShare();
  }

  // if ($('#friends-amp-family').length) {
  //   shareListByEmail();
  // }
};

// The wishlist icon from the product overview is the reference (native button). It takes a short moment to get all the necessary classes
let count_is_loaded_wishlist = 0;
const propagateWishlistStateToStickyAddToCart = (on_init = false) => {
  // 30 seconds max
  const stop_after = 30;
  const is_loaded = $('[data-product-overview] .swym-add-to-wishlist').hasClass('swym-loaded');
  console.log(`[wishlist] is_loaded #${count_is_loaded_wishlist}`, is_loaded);

  // It takes a few seconds for the wishlist to initialize
  if (on_init && count_is_loaded_wishlist < stop_after) {
    if (!is_loaded) {
      window.setTimeout(() => {
        propagateWishlistStateToStickyAddToCart(on_init);
        count_is_loaded_wishlist++;
      }, 1000);
    }

    if (typeof window.theme.customer.id === 'undefined') {
      $('.swym-btn-container').prepend('<div class="product-actions__wishlist-clickable" data-wishlist-clickable aria-label="Wishlist" role="button" tabindex="0" data-open-signin-actions-modal="wishlist"></div>');
    } else {
      $('.swym-btn-container').prepend('<div class="product-actions__wishlist-clickable" data-wishlist-clickable aria-label="Wishlist" role="button" tabindex="0"></div>');
    }
  }

  /*
  if (!is_loaded) {
    return;
  }
  
  let count_wishlist_added_check = 0;
  const wishlist_added_ready = window.setInterval(() => {
    count_wishlist_added_check++;

    const is_added = $('[data-product-overview] .swym-add-to-wishlist').hasClass('swym-added');
    console.log('[wishlist] is_added', is_added);

    if (is_added) {
      $('[data-product-details-wishlist]').addClass('active');
      window.clearInterval(wishlist_added_ready);
    } else {
      $('[data-product-details-wishlist]').removeClass('active');

      if (count_wishlist_added_check > 100) {
        window.clearInterval(wishlist_added_ready);
      }
    }
  }, 250);
  */
};

export {
  initWishlist,
  initProductTileWishlist,
  propagateWishlistStateToStickyAddToCart,
};
